import { render, staticRenderFns } from "./MyDesk.vue?vue&type=template&id=68fd9dca"
import script from "./MyDesk.vue?vue&type=script&lang=ts"
export * from "./MyDesk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports